// Laudo bloqueado por falta de crédito do Parceiro (migrations/laudo_aguardando_credito.sql).
type ComMarca = { aguardandoCreditoDesde?: Date | string | null };

export const MOTIVO_LAUDO_AGUARDANDO_CREDITO =
  "Este laudo está aguardando crédito. Compre 1 crédito do tipo de veículo para liberar o PDF.";

export const laudoAguardandoCredito = (l: ComMarca): boolean => Boolean(l.aguardandoCreditoDesde);

export const pdfBloqueadoPorCredito = (l: ComMarca): { bloqueado: true; motivo: string } | null =>
  laudoAguardandoCredito(l) ? { bloqueado: true, motivo: MOTIVO_LAUDO_AGUARDANDO_CREDITO } : null;
